import type { FieldKey } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
import { experience } from '@jira/polaris__lib-analytics/src/ConstantsExperience.tsx';
import { wrapWithExperience } from '@jira/polaris__lib-analytics/src/createJpdExperience.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from './FieldsUpdate.types.tsx';
import { loadSelectedFields } from './loadSelectedFields.tsx';
import { setNewlyAddedGlobalFields } from './setNewlyAddedGlobalFields.tsx';

/**
 * The `dependencies` array is intended for the dependencies of Global Formula fields
 */
export const associateGlobalFields =
	(fieldKeys: FieldKey[], dependencies: FieldKey[] = []): Action<State, Props> =>
	async ({ dispatch }, { projectId, createAnalyticsEvent, globalFieldRemote }): Promise<void> => {
		if (projectId === undefined) {
			throw new Error('cannot associate field for unknown project');
		}
		await wrapWithExperience(experience.globalFieldsAdministration.globalFieldAssociate, () =>
			globalFieldRemote.addGlobalFieldsToProject({
				fieldKeys,
				projectId,
			}),
		);

		const allNewFields: FieldKey[] = [...fieldKeys, ...dependencies];
		await dispatch(loadSelectedFields(allNewFields));
		dispatch(setNewlyAddedGlobalFields(allNewFields));

		fireTrackAnalytics(createAnalyticsEvent({}), 'field associated', {
			issueFieldKeys: fieldKeys,
		});
	};
